<!-- Copyright 2022, Common Good Learning Tools LLC -->
<!--
 Switches between the legacy resource usage report (resource_usage_report via admin_get_resource_usage_data)
 and the new cubby-backed report, based on site_config.cubby_enabled
 -->
<template>
	<AdminResourceUsageNew v-if="cubby_enabled" />
	<AdminResourceUsageLegacy v-else :course_code="course_code" />
</template>

<script>
import { mapState } from 'vuex'
import AdminResourceUsageLegacy from './AdminResourceUsageLegacy'
import AdminResourceUsageNew from './AdminResourceUsageNew'

export default {
	components: { AdminResourceUsageLegacy, AdminResourceUsageNew },
	props: {
		course_code: { type: String, required: false, default() { return ''} },
	},
	computed: {
		...mapState(['site_config']),
		cubby_enabled() { return this.site_config.cubby_enabled === true },
	},
}
</script>
